"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.schema = exports.schemaId = void 0;

var firebase = _interopRequireWildcard(require("firebase/app"));

var _models = require("@knxlab/models");

var _Schemas = require("./Schemas");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var fakeData = [{
  id: "1",
  owner_id: "123",
  title: "Barbell Squat",
  description: "Un exercice n\xE9cessitant beaucoup de technique",
  sports: ["crosstraining", "boxe", "musculation"],
  level: 2,
  equipment: ["barbell"],
  mainMuscleGroup: ["quads"],
  otherMuscleGroup: ["lower_legs"]
}, {
  id: "2",
  title: "Kettlebell Squat",
  description: "Un exercice n\xE9cessitant beaucoup de technique",
  sports: ["crosstraining", "musculation"],
  level: 2,
  equipment: ["barbell"],
  mainMuscleGroup: ["quads"],
  otherMuscleGroup: ["lower_legs"]
}, {
  id: "3",
  title: "Punches",
  description: "Un exercice pour d\xE9butant en boxe anglaise",
  tags: ["boxe"],
  level: 1,
  equipment: ["gloves"],
  mainMuscleGroup: ["quads"],
  otherMuscleGroup: ["chest"]
}];
var schemaId = "/Exercice";
exports.schemaId = schemaId;
var schema = {
  id: schemaId,
  type: "object",
  properties: {
    id: {
      type: "string"
    },
    owner: {
      type: "string"
    },
    title: {
      type: "string"
    },
    description: {
      type: "string"
    },
    level: {
      type: "integer",
      minimum: 1,
      maximum: 3
    },
    tags: {
      type: "array",
      items: {
        type: "string"
      }
    },
    sports: {
      type: "array",
      items: {
        type: "string"
      }
    },
    equipments: {
      type: "array",
      items: {
        type: "string"
      }
    },
    mainMuscleGroup: {
      type: "array",
      items: {
        type: "string"
      }
    },
    otherMuscleGroup: {
      type: "array",
      items: {
        type: "string"
      }
    },
    image: _Schemas.imageVideoMedia,
    video: _Schemas.imageVideoMedia
  }
};
exports.schema = schema;
var NAME = "Exercice";

var Exercice = /*#__PURE__*/function (_AbstractObject) {
  _inherits(Exercice, _AbstractObject);

  var _super = _createSuper(Exercice);

  function Exercice() {
    _classCallCheck(this, Exercice);

    return _super.apply(this, arguments);
  }

  _createClass(Exercice, [{
    key: "getTitle",
    value: function getTitle() {
      return this.title || "";
    }
  }, {
    key: "getName",
    value: function getName() {
      return NAME;
    }
  }, {
    key: "test",
    value: function test() {}
  }, {
    key: "getExecutionTime",
    value: function getExecutionTime() {
      return this.level === 1 ? 2 : 3;
    }
  }, {
    key: "save",
    value: function () {
      var _save = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var db, result;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.owner) {
                  _context.next = 2;
                  break;
                }

                throw new Error("Does not have an owner!");

              case 2:
                db = firebase.firestore();

                if (!this.id) {
                  _context.next = 8;
                  break;
                }

                _context.next = 6;
                return db.collection("exercices").doc(this.id).set(this["export"]());

              case 6:
                _context.next = 12;
                break;

              case 8:
                _context.next = 10;
                return db.collection("exercices").add(this["export"]());

              case 10:
                result = _context.sent;
                this.id = result.id;

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function save() {
        return _save.apply(this, arguments);
      }

      return save;
    }()
  }, {
    key: "delete",
    value: function () {
      var _delete2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var db;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (this.id) {
                  _context2.next = 2;
                  break;
                }

                throw new Error("Cannot delete an object that does not exists yet");

              case 2:
                db = firebase.firestore();
                _context2.next = 5;
                return db.collection("exercices").doc(this.id)["delete"]();

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function _delete() {
        return _delete2.apply(this, arguments);
      }

      return _delete;
    }()
  }], [{
    key: "get",
    value: function () {
      var _get = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(_ref) {
        var id, owner, db, exerciceData, exercice;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                id = _ref.id, owner = _ref.owner;
                db = firebase.firestore();
                _context3.next = 4;
                return db.collection("exercices").doc(id).get();

              case 4:
                exerciceData = _context3.sent;

                if (exerciceData.exists) {
                  _context3.next = 7;
                  break;
                }

                throw new Error("does not exists");

              case 7:
                exercice = new Exercice();
                exercice.setData(exerciceData.data());
                exercice.id = exerciceData.id;
                return _context3.abrupt("return", exercice);

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function get(_x) {
        return _get.apply(this, arguments);
      }

      return get;
    }()
  }, {
    key: "getAll",
    value: function () {
      var _getAll = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(_ref2) {
        var owner, db, refCounter, countersRef, total, counters;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                owner = _ref2.owner;
                db = firebase.firestore();
                refCounter = db.collection("userscounter").doc(owner);
                _context4.next = 5;
                return refCounter.get();

              case 5:
                countersRef = _context4.sent;
                total = null;

                if (countersRef.exists) {
                  counters = countersRef.data();
                  total = counters.exercices || null;
                }

                _context4.next = 10;
                return (0, _models.getListFromFirebaseRef)(db.collection("exercices").where("owner", "==", owner), {
                  limit: 100
                }, function (doc) {
                  var exercice = new Exercice();
                  exercice.setData(doc.data());
                  exercice.id = doc.id;
                  return exercice;
                }, {
                  total: total
                });

              case 10:
                return _context4.abrupt("return", _context4.sent);

              case 11:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function getAll(_x2) {
        return _getAll.apply(this, arguments);
      }

      return getAll;
    }()
  }, {
    key: "getRandomData",
    value: function getRandomData() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var exercice = new Exercice();
      exercice.setData(fakeData[index > 0 && index < fakeData.length ? index : 0]);
      return exercice;
    }
  }]);

  return Exercice;
}(_models.AbstractObject);

exports["default"] = Exercice;
Exercice.register({
  name: NAME,
  schema: schema,
  __class: Exercice
});